'use strict';

var chunkLLS5IGH4_js = require('./chunk-LLS5IGH4.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var a = require('react');
var styledComponents = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var a__default = /*#__PURE__*/_interopDefault(a);

var z=styledComponents.styled.button`
  background-color: ${({$backgroundColor:o,$loading:r,$loaderBgColor:n})=>r&&n||o};
  border: ${({$borderColor:o})=>o&&`1px solid ${o}`||"none"};
  color: ${({$color:o})=>o};
  padding: ${({$padding:o})=>o};
  height: ${({$height:o})=>o};
  outline: none;
  border-radius: ${({$borderRadius:o})=>o};
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({$fontSize:o})=>o};
  line-height: ${({$lineHeight:o})=>o};
  min-width: 100px;
  font-weight: ${({$fontWeight:o})=>o};
  width: 100%;
  cursor: pointer;
  transition: transform 0.2s, filter 0.3s;

  &:hover, &:focus {
    background-color: ${({$hoverBgColor:o,$backgroundColor:r})=>o||r};
    color: ${({$hoverColor:o,$color:r})=>o||r};
  }

  &:disabled {
    background-color: ${({$disabledBgColor:o,$backgroundColor:r})=>o||r};
    color: ${({$disabledColor:o,$color:r})=>o||r};
    pointer-events: none;
    border: ${({$disabledBorderColor:o})=>`1px solid ${o}`||"none"}
  }

  &:active {
    transform: scale(0.98);
    filter: brightness(80%);
    background-color: ${({$pressedBgColor:o,$backgroundColor:r})=>o||r};
    color: ${({$pressedColor:o,$color:r})=>o||r};
  }
`,D=styledComponents.styled.span`
  height: ${({$size:o})=>o};
  width: ${({$size:o})=>o};

  ${({$loading:o,$size:r,$loaderColor:n})=>o?`
        &.turboSpinnerLoader {
          height: ${r};
          width: ${r};
          -webkit-animation: rotate 0.8s infinite linear;
          animation: loading 0.8s infinite linear;
          border: 2px solid ${n};
          border-right-color: transparent;
          border-radius: 50%;
          display: block;
        }
      `:""}

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`,q=({label:o="Button",onClick:r,type:n="button",disabled:u,loading:s,prefixIcon:g,suffixIcon:p,size:i="medium",variant:e="primary",theme:I="default"})=>{var c,b,f,h,m,B,C,y,S,k,w,P,x,E,H;let{tokens:$}=chunkHUKGHOBJ_js.b(),{variants:T,sizes:l}=chunkLLS5IGH4_js.a($),t=T[I];return a__default.default.createElement(z,{disabled:!!u,onClick:async d=>{if(u){d.preventDefault(),d.stopPropagation();return}if(s){d.preventDefault(),d.stopPropagation();return}r==null||r(d);},type:n,$backgroundColor:(c=t[e])==null?void 0:c.bgColor,$color:(b=t[e])==null?void 0:b.color,$padding:(f=l[i])==null?void 0:f.padding,$height:(h=l[i])==null?void 0:h.height,$borderRadius:(m=l[i])==null?void 0:m.cornerRadius,$fontSize:(B=l[i])==null?void 0:B.fontSize,$lineHeight:(C=l[i])==null?void 0:C.lineHeight,$disabledBgColor:(y=t[e])==null?void 0:y.disabledBgColor,$disabledColor:(S=t[e])==null?void 0:S.disabledColor,$pressedColor:(k=t[e])==null?void 0:k.pressedColor,$pressedBgColor:(w=t[e])==null?void 0:w.pressedBgColor,$fontWeight:$.font_weight_semibold,$loading:s,$loaderBgColor:(P=t[e])==null?void 0:P.loaderBgColor,$disabledBorderColor:(x=t[e])==null?void 0:x.disabledBorderColor,$borderColor:(E=t[e])==null?void 0:E.borderColor},s?a__default.default.createElement(D,{$size:$.icon_size_16,$loading:s,className:"turboSpinnerLoader",$loaderColor:(H=t[e])==null?void 0:H.loaderColor}):a__default.default.createElement(a__default.default.Fragment,null,g&&g,o,p&&p))};

exports.a = q;
